export default function userHasRoles(user: any, requiredRoles: any) {
    if (user !== undefined) {
        const userRoles = user.roles?.map((item: any) => item.reference);

        return requiredRoles.some((role: any) => userRoles?.includes(role));
    }

    return false;
}
